import React, { useState } from 'react';
import { MdEmail, MdLocationOn, MdCheckCircle } from 'react-icons/md';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (!formData.name.trim()) {
      setError('Please enter your name');
      return;
    }
    if (!formData.email.trim()) {
      setError('Please enter your email');
      return;
    }
    if (!formData.email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }
    if (!formData.message.trim()) {
      setError('Please enter a message');
      return;
    }

    setSubmitting(true);

    try {
      // Create mailto link with pre-filled subject and body
      const subject = encodeURIComponent(`Contact Form: ${formData.name}`);
      const body = encodeURIComponent(
        `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
      );
      const mailtoLink = `mailto:support@tollyhype.com?subject=${subject}&body=${body}`;
      
      // Open email client
      window.location.href = mailtoLink;
      
      // Show success message after a short delay
      setTimeout(() => {
        setSubmitted(true);
        setFormData({ name: '', email: '', message: '' });
        setSubmitting(false);
        
        // Reset success message after 5 seconds
        setTimeout(() => {
          setSubmitted(false);
        }, 5000);
      }, 500);
    } catch (err) {
      setError('Failed to open email client. Please email us directly at support@tollyhype.com');
      setSubmitting(false);
    }
  };

  return (
    <div className="content-page-container">
      <div className="content-page-card">
        <h1>Contact Us</h1>
        <p className="intro-text">
          We'd love to hear from you! Whether you have a question about features, need help with your account, or just want to suggest a movie we missed, our team is ready to answer all your questions.
        </p>

        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-item">
              <div className="icon-circle">
                <MdEmail size={24} />
              </div>
              <div>
                <h3>Email Us</h3>
                <p>For general inquiries and support:</p>
                <a href="mailto:support@tollyhype.com" className="contact-link">support@tollyhype.com</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="icon-circle">
                <MdLocationOn size={24} />
              </div>
              <div>
                <h3>Location</h3>
                <p>Hyderabad, Telangana</p>
                <p>India</p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h3>Send us a Message</h3>
            {submitted ? (
              <div className="contact-success">
                <MdCheckCircle size={32} />
                <p>Thank you for your message! Your email client should open shortly. If it doesn't, please email us directly at support@tollyhype.com</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                {error && (
                  <div className="contact-error">
                    {error}
                  </div>
                )}
                
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    placeholder="Your name" 
                    className="form-input"
                    value={formData.name}
                    onChange={handleChange}
                    disabled={submitting}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    placeholder="Your email" 
                    className="form-input"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={submitting}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea 
                    id="message" 
                    rows="5" 
                    placeholder="How can we help?" 
                    className="form-textarea"
                    value={formData.message}
                    onChange={handleChange}
                    disabled={submitting}
                    required
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={submitting}
                >
                  {submitting ? 'Opening Email...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

